var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dormitory-front"},[_c('lead',{attrs:{"headOption":_vm.headOption}}),(_vm.managerole)?_c('div',{staticClass:"dormitory-manage",on:{"click":_vm.goManage}},[_vm._v("宿舍管理")]):_vm._e(),_c('main',{staticClass:"main"},[_c('router-view')],1),_c('foote')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }